import InputField from '../../../../FormControl/input/InputField';

const FilterButtonUser = ({ onFilter }) => (
  <div className='flex gap-4 items-center'>
    <InputField
      id='search'
      placeholder='Search'
      variant='outlined'
      fullWidth
      size='medium'
      onChange={(e) => onFilter(e.target.value)}
    />
  </div>
);
export default FilterButtonUser;
